import { jsx as _jsx } from "react/jsx-runtime";
import { FilterQueryHandlerType, useCategoryFilterHandler } from "@/hooks/useCategoryFilterHandler";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { useTreeItem2Utils } from "@mui/x-tree-view/hooks";
import { unstable_useTreeItem2 as useTreeItem2 } from "@mui/x-tree-view/useTreeItem2";
import { forwardRef } from "react";
import { CustomTreeItem } from ".";
export const CategoryTreeItem = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { id , itemId , label , disabled , children  } = props;
    const { filterQueryHandler  } = useCategoryFilterHandler();
    const { interactions  } = useTreeItem2Utils({
        itemId,
        children
    });
    const { publicAPI  } = useTreeItem2({
        id,
        itemId,
        label,
        children,
        disabled,
        rootRef: ref
    });
    const item = publicAPI.getItem(itemId);
    const handleContentClick = (event)=>{
        interactions.handleSelection(event);
        filterQueryHandler({
            filterType: FilterQueryHandlerType.CATEGORY,
            value: item.id
        });
        mixpanelEvent("Category LNB Clicked", {
            Depth: item.id.length / 2,
            buttonName: item.name
        });
    };
    const handleIconContainerClick = (event)=>{
        interactions.handleExpansion(event);
    };
    return /*#__PURE__*/ _jsx(CustomTreeItem, {
        ...props,
        ref: ref,
        slotProps: {
            iconContainer: {
                onClick: handleIconContainerClick
            },
            label: {
                onClick: handleContentClick
            }
        }
    });
});
CategoryTreeItem.displayName = "CategoryTreeItem";
